<template>
  <section class="anchor device" :id="$t('header.nav[2].link')">
    <div class="container">
      <div class="row">
        <div class="col-x-lg-6 col-lg-7 col-md-7 col-sm-7 col-xs-12">
          <div class="device__description">
            <h2
              class="device__description-title"
              v-html="$t('home.device.title')"
            ></h2>
            <h5
              class="device__description-subtitle"
              v-html="$t('home.device.subtitle')"
            ></h5>
            <div
              class="device__description-text"
              v-html="$t('home.device.text')"
            ></div>
            <div class="device__description-list">
              <div
                class="device__description-list-title"
                v-html="$t('home.device.list.title')"
              ></div>
              <div
                class="device__description-list-item"
                v-html="$t('home.device.list.item_1')"
              ></div>
              <div
                class="device__description-list-item"
                v-html="$t('home.device.list.item_2')"
              ></div>
            </div>
            <router-link
              @click.native="mainMaThing()"
              :to="$t('home.device.button.link')"
              class="device__description-btn"
            >
              {{ $t("home.device.button.title") }}
            </router-link>
          </div>
        </div>
        <div class="col-x-lg-6 col-lg-5 col-md-5 col-sm-5 col-xs-12">
          <div class="device__image" v-if="$i18n.locale === 'ua'">
            <img
              v-if="isResponsive"
              src="~@/assets/img/home/device/device-mobile-ua.png"
              alt=""
            />
            <img v-else src="~@/assets/img/home/device/device-ua.png" alt="" />
          </div>
          <div class="device__image" v-if="$i18n.locale === 'ru'">
            <img
              v-if="isResponsive"
              src="~@/assets/img/home/device/device-mobile-ru.png"
              alt=""
            />
            <img v-else src="~@/assets/img/home/device/device-ru.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["isResponsive"],
  name: "Device",
  methods: {
    mainMaThing() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "main_ma_thing" });
    }
  }
};
</script>
